import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getSelectedCalendars } from 'owa-calendar-surface-calendars-store';
import { getStore } from '../store/store';
import { DateRange } from 'owa-datetime-utils';
import { fetchCalendarEventsForDateRange } from '../utils/calendarEventsLockedStore';
import { getCalendarFolderId } from 'owa-calendar-cache';
import { EventsCacheLockId, getLockedCalendarEventsStore } from 'owa-calendar-events-store';

/**
 * Gets a list of items for the specified date range for the given folder
 * @param dateRange The date range for which to request calendars
 * @return A promise that returns an array of calendar items for the given calendar
 */
export function getItemsForFolder(
    dateRange: DateRange,
    folderId: string,
    eventsCacheLockId?: EventsCacheLockId
): Promise<CalendarEvent[]> {
    if (!eventsCacheLockId) {
        // if no lockId is passed, then use the top level lock for surface
        eventsCacheLockId = getStore().surfaceEventsLockId;
    }
    const lockedStore = getLockedCalendarEventsStore(eventsCacheLockId);
    lockedStore.subscribeNotifications(folderId);
    return fetchCalendarEventsForDateRange(eventsCacheLockId, folderId, dateRange);
}

/**
 * Gets a list of items for the specified date range for each selected calendar
 * @param dateRange The date range for which to request calendars
 * @return A array of promises that returns an array of calendar items for each selected calendar
 */
export function getItemsForAllFolders(
    dateRange: DateRange,
    eventsCacheLockId?: EventsCacheLockId
): Promise<CalendarEvent[]>[] {
    if (!eventsCacheLockId) {
        // if no lockId is passed, then use the top level lock for surface
        eventsCacheLockId = getStore().surfaceEventsLockId;
    }

    const selectedCalendars = getSelectedCalendars();
    if (selectedCalendars.length == 0) {
        return [Promise.resolve(null)];
    } else {
        return selectedCalendars.map(calendar => {
            // Get the calendar folder id from the calendars cache
            const calendarFolderId = getCalendarFolderId(calendar);
            if (calendarFolderId) {
                return getItemsForFolder(dateRange, calendarFolderId, eventsCacheLockId);
            } else {
                return Promise.resolve([]);
            }
        });
    }
}
